import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | MESCO Springs</title>
      </Helmet>
      <div className="min-h-[70vh] flex items-center justify-center pt-24 blueprint-grid" data-testid="not-found">
        <div className="text-center px-6">
          <p className="font-mono-spec text-[11px] tracking-[0.35em] uppercase text-[#334772]">[ ERROR 404 ]</p>
          <h1 className="font-display text-7xl sm:text-9xl uppercase text-[#334772] mt-4">Off the load line</h1>
          <p className="mt-4 text-[#706F70]">The page you are looking for has been compressed out of existence.</p>
          <Link to="/" data-testid="not-found-home" className="mt-8 inline-block px-8 py-4 bg-[#334772] text-white text-sm font-bold uppercase tracking-[0.15em] hover:bg-[#2A3C60] transition-colors">
            Back to home
          </Link>
        </div>
      </div>
    </>
  );
}
